const Skull = ({ color = "#FAFAFA", size = 20 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <mask
          id='mask0_2099_54054'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='24'
          height='24'
        >
          <rect width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_2099_54054)'>
          <path
            d='M6 22V17.75C5.35 17.4667 4.77933 17.0877 4.288 16.613C3.796 16.1377 3.37933 15.6 3.038 15C2.696 14.4 2.43767 13.7583 2.263 13.075C2.08767 12.3917 2 11.7 2 11C2 8.36667 2.93333 6.20833 4.8 4.525C6.66667 2.84167 9.06667 2 12 2C14.9333 2 17.3333 2.84167 19.2 4.525C21.0667 6.20833 22 8.36667 22 11C22 11.7 21.9127 12.3917 21.738 13.075C21.5627 13.7583 21.3043 14.4 20.963 15C20.621 15.6 20.2043 16.1377 19.713 16.613C19.221 17.0877 18.65 17.4667 18 17.75V22H6ZM8 20H9V18H11V20H13V18H15V20H16V16.45C16.6333 16.3 17.196 16.05 17.688 15.7C18.1793 15.35 18.596 14.9333 18.938 14.45C19.2793 13.9667 19.5417 13.4333 19.725 12.85C19.9083 12.2667 20 11.65 20 11C20 8.91667 19.2627 7.22933 17.788 5.938C16.3127 4.646 14.3833 4 12 4C9.61667 4 7.68767 4.646 6.213 5.938C4.73767 7.22933 4 8.91667 4 11C4 11.65 4.09167 12.2667 4.275 12.85C4.45833 13.4333 4.72067 13.9667 5.062 14.45C5.404 14.9333 5.825 15.35 6.325 15.7C6.825 16.05 7.38333 16.3 8 16.45V20ZM10.5 15H13.5L12 12L10.5 15ZM8.5 13C9.05 13 9.521 12.804 9.913 12.412C10.3043 12.0207 10.5 11.55 10.5 11C10.5 10.45 10.3043 9.979 9.913 9.587C9.521 9.19567 9.05 9 8.5 9C7.95 9 7.47933 9.19567 7.088 9.587C6.696 9.979 6.5 10.45 6.5 11C6.5 11.55 6.696 12.0207 7.088 12.412C7.47933 12.804 7.95 13 8.5 13ZM15.5 13C16.05 13 16.521 12.804 16.913 12.412C17.3043 12.0207 17.5 11.55 17.5 11C17.5 10.45 17.3043 9.979 16.913 9.587C16.521 9.19567 16.05 9 15.5 9C14.95 9 14.4793 9.19567 14.088 9.587C13.696 9.979 13.5 10.45 13.5 11C13.5 11.55 13.696 12.0207 14.088 12.412C14.4793 12.804 14.95 13 15.5 13Z'
            fill={color}
          />
        </g>
      </svg>
    </>
  );
};

export default Skull;
